export default __webpack_public_path__ + "static/media/program2018.4e29460a.pdf";